'use client'
import BasketHeader from '../BasketHeader'
import { Button } from '@/components/Button'
import { useTranslation } from 'react-i18next'
import BasketTotal from '../BasketTotal'
import BasketProductTable from '../BasketProductTable'
import { useCallback, useContext, useState } from 'react'
import { BasketContext } from '../BasketProvider'
import { EshopContext } from '../EshopProvider'
import { useUser } from '@/eshop/hooks/useUser'
import { useUpdateBasketPrice } from '../BasketCommon/useUpdateBasketPrice'

export function BasketOne() {
    const { t } = useTranslation()
    const { products, isLoading } = useContext(BasketContext)
    const { setShowLoginModal } = useContext(EshopContext)
    const user = useUser()

    const isUserLoggedIn = !!user

    const handleContinueClick = useCallback(() => {
        if (!isUserLoggedIn) {
            setShowLoginModal('login')
        }
    }, [isUserLoggedIn, setShowLoginModal])

    const priceState = useUpdateBasketPrice()

    const isEmpty = !products || products.length === 0

    return (
        <div className="flex flex-col items-center justify-center mt-20">
            <BasketHeader step={1} />
            <div className="mt-20 w-full mb-40">
                <BasketProductTable isEditable />

                <BasketTotal />
                <div className="flex justify-between mt-10">
                    <Button type="wide" outline url="/eshop">
                        {t('eshop.basket.eshop')}
                    </Button>
                    <Button
                        url={
                            isUserLoggedIn
                                ? '/eshop/basket/delivery'
                                : undefined
                        }
                        color="secondary"
                        disabled={
                            isEmpty || isLoading || priceState === 'error'
                        }
                        onClick={
                            isUserLoggedIn ? undefined : handleContinueClick
                        }
                    >
                        {isLoading && priceState !== 'error' ? (
                            <span className="loading loading-spinner loading-lg mx-6"></span>
                        ) : isUserLoggedIn ? (
                            t('eshop.basket.continue1')
                        ) : (
                            t('eshop.basket.logIn')
                        )}
                    </Button>
                </div>
                {priceState === 'error' && (
                    <div className="text-right text-red-700 mt-2 mr-2">
                        {t('eshop.basket.pricesError')}
                    </div>
                )}
            </div>
        </div>
    )
}
